import { forwardRef } from 'react';
import { assert } from './utils/assert';
import { objectToGetParams } from './utils/objectToGetParams';
import { ShareButton, type ShareButtonProps } from './ShareButton';

function okLink(
  url: string,
  { shareTitle, description, image }: { shareTitle?: string; description?: string; image?: string },
) {
  assert(url, 'ok.url');

  return (
    'https://connect.ok.ru/offer' +
    objectToGetParams({
      url,
      title: shareTitle,
      description,
      imageUrl: image,
    })
  );
}

export const buildOKShareUrl = okLink;

type OKShareButtonProps = Omit<
  ShareButtonProps<{ shareTitle?: string; description?: string; image?: string }>,
  'title'
> & {
  description?: string;
  image?: string;
  shareTitle?: string;
};

export const OKShareButton = forwardRef<HTMLButtonElement, OKShareButtonProps>(
  ({ description, image, shareTitle, ...props }, ref) => (
    <ShareButton
      {...props}
      forwardedRef={ref}
      networkName="ok"
      networkLink={buildOKShareUrl}
      opts={{
        shareTitle,
        description,
        image,
      }}
      windowHeight={480}
      windowPosition="screenCenter"
      windowWidth={588}
    />
  ),
);

OKShareButton.displayName = 'OKShareButton';
